import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { ExpertContext } from "../../data/expert_context_management";
import useExpertEmploymentsApi from "../../data/use_expert_employments_api";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
// The editor table is plain chrome driven entirely by its `employmentState` prop — no PR-specific
// logic — so the expert page drives the same one rather than forking it. Same reasoning as the
// provider reusing that folder's serializer for these rows.
import EmploymentEditorActive from "../../../pr_profiles/edit/employment_modal_body/EmploymentEditorActive";

const EMPLOYMENT_ERROR_LABELS = { started_at: "Start date", ended_at: "End date", title: "Title" };

// Reads the employment collection + plumbing straight from ExpertContext (the provider owns the
// collection — no modal-local fetch or loading state) and performs writes via use_expert_employments_api.
// Same context-based shape as the expert HeaderModalBody.
//
// The collection is fed here UNFILTERED, deliberately: the show page hides rows flagged personHidden,
// but this is the surface for managing them, so they have to be listed and editable here. (RLS on
// id_company_jobs is what decides whether hidden rows are readable at all.)
function EmploymentModalBody({ close }) {
  const context = useContext(ExpertContext);
  const { companyJobs, generalError, isUpdating } = context;
  const { addEmployment, removeEmployment, setFeatured, updateEmployment } = useExpertEmploymentsApi({ ...context });

  const employmentState = {
    employments: companyJobs || [],
    addEmployment,
    removeEmployment,
    setFeatured,
    updateEmployment,
    isUpdating,
  };

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} labelMap={EMPLOYMENT_ERROR_LABELS} />
        <EmploymentEditorActive employmentState={employmentState} />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default EmploymentModalBody;
